import React, { memo, useCallback, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import "@css/pages/employer/DocumentsEmployers/courseCertifications.css";
import "@css/pages/employer/listeEmployer.css";
import AddButton from "@components/buttons/AddButton";
import CertificationList from "./CertificationList";
import { ModalAddOrUpdateCertification as ModalAddCertification } from "./modals";
import { useUserPermission } from "@hooks/users";

const SharedCertification = ({ id, readOnly, certifications, isEnterprisePage, userConnected, isLoading }) => {
  const { t } = useTranslation("pages.employés.parcours&Certifications");
  const [isOpenModal, setIsOpenModal] = useState(false);
  const { canAccessCertsLicenses } = useUserPermission();

  const toggleCertifications = useCallback(
    () => setIsOpenModal((_isOpenModal) => !_isOpenModal),
    []
  );

  const isReadOnly = useMemo(() => {
    return isEnterprisePage ? readOnly : (readOnly && !canAccessCertsLicenses);
  }, [readOnly, isEnterprisePage, canAccessCertsLicenses])

  return (
    <>
      <div className="arh-pr-4 arh-pl-24 arh-pb-8 arh-w-full arh-flex arh-flex-col">
        {isReadOnly ? (
          <div
            className="head_certification employerSvgAdd d-flex flex-justify-between flex-align-center"
            id="ModalsCertifications"
          ></div>
        ) : (
          <div className="arh-mb-8">
            <AddButton
              label={t("Ajouter une certification")}
              onClick={toggleCertifications}
              color="arh-bg-greenColor hover:arh-bg-darkGreenColor"
            />
          </div>
        )}

        {/* LISTES DES CERTIFICATIONS */}
        <CertificationList 
          certifications={certifications} 
          idEmployer={id} 
          isReadOnly={isReadOnly}
          isEnterprisePage={isEnterprisePage}
          userConnected={userConnected} 
          isLoading={isLoading}
        />
      </div>

      <ModalAddCertification
        isOpen={isOpenModal}
        idEmployer={id}
        onClickClose={toggleCertifications}
        isEnterprisePage={isEnterprisePage}
        userConnected={userConnected}
      />
    </>
  );
};

export default memo(SharedCertification);
